export const V5_MARKETS_VALUE = 4;

export const isV5MarketsExperience = (whichMarkets?: number | null) =>
  whichMarkets === V5_MARKETS_VALUE;

export const isV5MarketsLocation = (
  pathname: string,
  whichMarkets?: number | null,
) => /\/markets\/?$/.test(pathname) && isV5MarketsExperience(whichMarkets);
